const $ = jQuery.noConflict();

'use strict';

const SearchAjax = {
	suggestions: [],
	inputSelector: '.js-search-form-input',
	formSelector: '.js-site-header__search-form',
	suggestionsBox: null,
	endpoint: '/wp-json/fws-listing-shop/v1/products',
	input: null,
	form: null,

	init() {
		if (window.FWS_SUGGESTIONS) {
			this.setSuggestions(window.FWS_SUGGESTIONS);
		}
		this.input = document.querySelector(this.inputSelector);
		this.form = document.querySelector(this.formSelector) || this.input?.form;
		if (!this.input || !this.form) return;

		this.suggestionsBox = document.createElement('div');
		this.suggestionsBox.className = 'search-suggestions-box';
		this.input.parentNode.appendChild(this.suggestionsBox);
		this.addLoaderOnShoRedirection();
		// Debounce za automatski search
		let debounceTimeout = null;
		this.input.addEventListener('input', (e) => {
			const value = e.target.value;
			this.showSuggestions(value);
			this.showDidYouMean(value);
			if (debounceTimeout) clearTimeout(debounceTimeout);

			// Ne pokreći search ako je input prazan
			if (!value || value.trim() === '') {
				this.input.classList.remove('is-loading');
				$('.js-search-loader').removeClass('is-visible');
				return;
			}

			debounceTimeout = setTimeout(() => {
				// Pokreni loader
				this.input.classList.add('is-loading');
				$('.js-search-loader').addClass('is-visible');
				if (window.location.pathname === '/shop' || window.location.pathname === '/shop/') {
					// Ažuriraj search parametar u URL-u
					const url = new URL(window.location.origin + '/shop');
					url.search = '';
					url.searchParams.set('search', value);
					window.history.pushState({}, '', url.toString());
					this.resetShopFilters();
				}
				this.doSearch(value);
				// if (window.innerWidth < 768) {
				// 	if (typeof document !== 'undefined' && document.activeElement) {
				// 		document.activeElement.blur();
				// 	}
				// }
			}, window.innerWidth < 768 ? 1500 : 500);
		});
		this.input.addEventListener('keydown', (e) => {
			if (e.key === 'Enter') {
				e.preventDefault();
				const value = this.input.value;
				this.hideSuggestions();
				if (window.location.pathname === '/shop' || window.location.pathname === '/shop/') {
					// Na shop stranici, enter radi isto što i debounce: pokreće search
					this.input.classList.add('is-loading');
					// $('.js-search-loader').addClass('is-visible');
					this.doSearch(value);
				} else {
					// Na svim ostalim stranicama, redirektuj na shop sa search parametrom
					const url = new URL(window.location.origin + '/shop');
					url.search = '';
					url.searchParams.set('search', value);
					window.location.href = url.toString();
					document.body.classList.add('loader-visible');
				}
				// Zatvori tastaturu na mobilnim uređajima
				// if (window.innerWidth < 768) {
				// 	if (typeof document !== 'undefined' && document.activeElement) {
				// 		document.activeElement.blur();
				// 	}
				// }
			} else if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
				this.navigateSuggestions(e.key);
			} else if (e.key === 'Escape') {
				this.hideSuggestions();
			}
		});
		this.form.addEventListener('submit', (e) => {
			e.preventDefault();
			const value = this.input.value;
			this.hideSuggestions(); // 1. Sakrij suggestion box
			if (window.location.pathname === '/shop' || window.location.pathname === '/shop/') {
				const url = new URL(window.location.origin + '/shop');
				url.search = '';
				url.searchParams.set('search', value);
				window.history.pushState({}, '', url.toString());
				this.resetShopFilters();
			} else {
				this.doSearch(value);
			}
			// Zatvori tastaturu na mobilnim uređajima
			// if (window.innerWidth < 768) {
			// 	if (typeof document !== 'undefined' && document.activeElement) {
			// 		document.activeElement.blur();
			// 	}
			// }
			// Ako je uređaj ispod 768px, sakrij formu
			// if (window.innerWidth < 768) {
			// 	const form = document.querySelector('.js-site-header__search-form');
			// 	if (form) form.style.display = 'none';
			// }
		});
		this.suggestionsBox.addEventListener('mousedown', (e) => {
			if (e.target && e.target.matches('.suggestion-item')) {
				e.preventDefault();
				this.input.value = e.target.textContent;
				this.hideSuggestions();
				// Prikazi loader na input
				$('.js-search-loader').addClass('is-visible');
				const value = e.target.textContent;
				if (window.location.pathname === '/shop' || window.location.pathname === '/shop/') {
					const url = new URL(window.location.origin + '/shop');
					url.search = '';
					url.searchParams.set('search', value);
					window.history.pushState({}, '', url.toString());
					this.resetShopFilters();
					// Ako je uređaj ispod 768px, sakrij formu
					if (window.innerWidth < 768) {
						const closeSearchForm = document.querySelector('.js-site-header__search-icon-close');
						if (closeSearchForm) closeSearchForm.click();
					}
				} else {
					this.doSearch(value);
				}
				// Zatvori tastaturu na mobilnim uređajima
				// if (window.innerWidth < 768) {
				// 	if (typeof document !== 'undefined' && document.activeElement) {
				// 		document.activeElement.blur();
				// 	}
				// }
			}
		});
		document.addEventListener('mousedown', (e) => {
			if (!this.suggestionsBox.contains(e.target) && e.target !== this.input) {
				this.hideSuggestions();
			}
		});
	},

	addLoaderOnShoRedirection() {
		$(document).on('click', '.js-see-all-products', () => {
			document.body.classList.add('loader-visible');
		});
	},

	// Resetuje sve filtere osim search-a na /shop stranici
	resetShopFilters() {
		const activeFiltersPills = document.querySelectorAll('.products-listing__holder-products-pill');
		console.log(activeFiltersPills);
		if (activeFiltersPills.length > 0) {
			for (let i = activeFiltersPills.length - 1; i >= 0; i--) {
				const pill = activeFiltersPills[i];
				const fullText = pill.firstChild.textContent.trim();
				const attrName = fullText.split(':')[0];
				console.log('Resetting filter:', attrName);
				if (attrName !== 'Pretraga') {
					const closeBtn = pill.querySelector('.products-listing__holder-products-pill-close');
					closeBtn.click();
				}
			}
		}
	},

	setSuggestions(suggestionsArray) {
		this.suggestions = suggestionsArray;
	},

	showSuggestions(query) {
		// Privremeno isključeno: ne prikazuj sugestije
		this.hideSuggestions();
		document.body.classList.remove('no-scroll');
		this.removeDidYouMean();
	},
	// Prikaz "Da li ste mislili?" ako postoji fuzzy match i nema sugestija
	showDidYouMean(query) {
		if (!query || query.length < 3) {
			this.removeDidYouMean();
			return;
		}
		// Ako postoje sugestije, ne prikazuj "da li ste mislili"
		const q = query.toLowerCase();
		const matches = this.suggestions.filter(s => s && s.toLowerCase().includes(q)).slice(0, 8);
		if (matches.length > 0) {
			this.removeDidYouMean();
			return;
		}
		// Fuzzy pronalazak najbolje sugestije
		let best = null;
		let bestScore = 1;
		this.suggestions.forEach(s => {
			if (!s) return;
			const sLow = s.toLowerCase();
			const dist = this.levenshtein(q, sLow);
			const score = dist / Math.max(q.length, sLow.length);
			if (score < bestScore && score < 0.5 && sLow !== q) {
				bestScore = score;
				best = s;
			}
		});
		this.removeDidYouMean();
		if (best) {
			// Prikazi ispod inputa
			const html = `<div class="js-search-suggestion search-didyoumean" style="padding:10px; font-style: italic; cursor: pointer; color: #0073aa; position: absolute; z-index: 100; background: #fff; border: 1px solid #eee; left: 0; right: 0;">Da li ste mislili: <span class="js-suggestion-text" style="text-decoration: underline;">${best}</span>?</div>`;
			this.input.insertAdjacentHTML('afterend', html);
			const sug = this.input.parentNode.querySelector('.js-suggestion-text');
			if (sug) {
				sug.addEventListener('click', () => {
					this.input.value = best;
					this.removeDidYouMean();
					this.showSuggestions(best);
					if (window.location.pathname === '/shop' || window.location.pathname === '/shop/') {
						const url = new URL(window.location.origin + '/shop');
						url.search = '';
						url.searchParams.set('search', best);
						window.history.pushState({}, '', url.toString());
						this.resetShopFilters();
					} else {
						this.doSearch(best);
					}
				});
			}
		}
	},

	removeDidYouMean() {
		const el = this.input.parentNode.querySelector('.search-didyoumean');
		if (el) el.remove();
	},

	// Levenshtein distance helper
	levenshtein(a, b) {
		const matrix = [];
		let i;
		for (i = 0; i <= b.length; i++) matrix[i] = [i];
		let j;
		for (j = 0; j <= a.length; j++) matrix[0][j] = j;
		for (i = 1; i <= b.length; i++) {
			for (j = 1; j <= a.length; j++) {
				if (b.charAt(i - 1) === a.charAt(j - 1)) {
					matrix[i][j] = matrix[i - 1][j - 1];
				} else {
					matrix[i][j] = Math.min(
						matrix[i - 1][j - 1] + 1, // substitution
						matrix[i][j - 1] + 1, // insertion
						matrix[i - 1][j] + 1 // deletion
					);
				}
			}
		}
		return matrix[b.length][a.length];
	},

	navigateSuggestions(key) {
		const items = Array.from(this.suggestionsBox.querySelectorAll('.suggestion-item'));
		if (!items.length) return;
		let idx = items.findIndex(item => item.classList.contains('selected'));
		items.forEach(item => item.classList.remove('selected'));
		if (key === 'ArrowDown') {
			idx = (idx + 1) % items.length;
		} else if (key === 'ArrowUp') {
			idx = (idx - 1 + items.length) % items.length;
		}
		items[idx].classList.add('selected');
		this.input.value = items[idx].textContent;
	},

	hideSuggestions() {
		this.suggestionsBox.innerHTML = '';
		this.suggestionsBox.style.display = 'none';
		this.suggestionsBox.classList.remove('search-suggestions-only');
		this.suggestionsBox.classList.remove('visible');
		if (this.form) this.form.classList.remove('has-search-results');
		document.body.classList.remove('no-scroll');
	},

	doSearch(query) {
		this.hideSuggestions();
		if (!query) return;
		// Ne prikazuj dropdown na /shop stranici
		if (window.location.pathname === '/shop' || window.location.pathname === '/shop/') {
			return;
		}
		// 2. Dodaj loader na input
		this.input.classList.add('is-loading');
		const params = new URLSearchParams({search: query});
		fetch(this.endpoint + '?' + params.toString(), {
			method: 'GET',
			headers: {'Accept': 'application/json'},
		})
			.then(res => res.json())
			.then(data => {
				let resultHTML = '';
				const products = Array.isArray(data.products) ? data.products : [];
				// Kategorije kao objekti sa cat_id, name, ...
				const categories = Array.isArray(data.categories) ? data.categories : [];
				const totalCount = data.total_products || 0;

				// Prikaz proizvoda
				resultHTML += '<div class="site-header__search-dropdown-products">';
				if (products.length > 0) {
					resultHTML += '<h4 class="site-header__search-dropdown-result-text" style="margin: 10px">Proizvodi</h4>';
					resultHTML += products.slice(0, 15).map(product => `
						<a class="site-header__search-dropdown-result" href="${window.origin}/product/${product.slug}">
							<div class="site-header__search-dropdown-result-image">
								<img class="site-header__search-dropdown-result-img" src="${product.image}" alt="Product Image">
							</div>
							<div class="site-header__search-dropdown-result-texts">
								${product.brand_image ? `
								<div class="site-header__search-dropdown-result-texts-image">
									<img class="site-header__search-dropdown-result-texts-img" src="${product.brand_image}" alt="Brand Image">
								</div>
								` : ''}
								<span class="site-header__search-dropdown-result-text">${product.title}</span>
							</div>
						</a>
					`).join('');
				}
				resultHTML += '</div>';


				// Prikaz kategorija kao u search.js (iz product_cat_data svakog proizvoda)
				const allCats = [];
				products.forEach(product => {
					if (Array.isArray(product.product_cat_data)) {
						product.product_cat_data.forEach(cat => {
							if (cat.cat_slug !== 'uncategorized') {
								allCats.push({
									name: cat.cat_name,
									link: cat.cat_link,
									slug: cat.cat_slug,
									cat_id: cat.cat_id
								});
							}
							if (Array.isArray(cat.children)) {
								cat.children.forEach(child => {
									if (child.cat_slug !== 'uncategorized') {
										allCats.push({
											name: child.cat_name,
											link: child.cat_link,
											slug: child.cat_slug,
											cat_id: child.cat_id
										});
									}
								});
							}
						});
					}
				});
				// Ukloni duplikate po slug-u
				const uniqueCats = Object.values(allCats.reduce((acc, cat) => {
					acc[cat.slug] = cat;
					return acc;
				}, {}));
				if (uniqueCats.length > 0) {
					resultHTML += `
						<div class="site-header__search-dropdown-categories">
							<h4 class="site-header__search-dropdown-result-text" style="margin: 10px">Kategorije</h4>
							${uniqueCats.slice(0, 15).map(cat => `
								<a class="site-header__search-dropdown-result" href="${window.location.origin}/shop/?category=${cat.cat_id}">
									<div class="site-header__search-dropdown-result-texts">
										<span class="site-header__search-dropdown-result-text">${cat.name}</span>
									</div>
								</a>
							`).join('')}
						</div>
					`;
				}

				// Dugme za sve rezultate
				if (products.length > 0 || categories.length > 0) {
					resultHTML += `
						<div class="site-header__search-dropdown-result-btn-wrap">
							<a class="site-header__search-dropdown-result-btn js-see-all-products" href="${window.location.origin}/shop/?search=${encodeURIComponent(query)}">
								Vidi sve rezultate (${totalCount})
							</a>
						</div>
					`;
				} else {
					resultHTML = '<p style="padding:10px">Nema rezultata.</p>';
				}

				this.suggestionsBox.innerHTML = resultHTML;
				this.suggestionsBox.style.display = 'flex';
				this.suggestionsBox.classList.remove('search-suggestions-only');
				this.suggestionsBox.classList.add('visible');
				document.body.classList.add('no-scroll');
				if (this.form) this.form.classList.add('has-search-results');
			})
			.catch(err => {
				console.error('Search error:', err);
			})
			.finally(() => {
				// 2. Ukloni loader sa inputa
				this.input.classList.remove('is-loading');
				$('.js-search-loader').removeClass('is-visible');
			});
	}

};

export default SearchAjax;